import React from 'react';
import PropTypes from 'prop-types';

const colors = {
  white: '#FFFFFF',
  lilac: '#F1CCFF',
};

export const ProfileIcon = ({ color = colors.white }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={colors[color]}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 20a6 6 0 0 0-12 0" />
    <circle cx={12} cy={10} r={4} />
    <circle cx={12} cy={12} r={10} />
  </svg>
);

ProfileIcon.displayName = 'CenterMenuLinks';

ProfileIcon.propTypes = {
  color: PropTypes.string,
};
